/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { EntityInformation } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of EntityConflictController.
 */
export class EntityConflictRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /references
     */
    public checkIsEntityNotInUse(entity: EntityInformation): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, EntityInformation>('/references', entity);
    }
}
